import React from "react";
import SuccessMessageModal from "@streeteasy/design-system/legacy/SuccessMessageModal";
import { func, object, shape } from "prop-types";

const AccountCreatedConfirmation = props => (
  <SuccessMessageModal isOpen onClose={props.handleCloseModal}>
    <SuccessMessageModal.Body>
      <SuccessMessageModal.SuccessIcon />
      <SuccessMessageModal.Title>
        Your message was sent
      </SuccessMessageModal.Title>
      <SuccessMessageModal.Text>
        {props.data.confirmationText}
      </SuccessMessageModal.Text>
    </SuccessMessageModal.Body>
  </SuccessMessageModal>
);

AccountCreatedConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired
  }).isRequired,
  handleCloseModal: func.isRequired
};

export default AccountCreatedConfirmation;
